import { useEffect, useRef } from 'react';

export const useFreshGuaranteesRequestError = (
  requestError: unknown,
  showGuaranteesRequestError: (error: unknown) => void
) => {
  const isInitialRenderRef = useRef(true);
  const initialRequestErrorRef = useRef(requestError);

  useEffect(() => {
    if (isInitialRenderRef.current) {
      isInitialRenderRef.current = false;
      return;
    }

    if (requestError && requestError === initialRequestErrorRef.current) {
      return;
    }

    if (requestError) {
      showGuaranteesRequestError(requestError);
    }
  }, [requestError, showGuaranteesRequestError]);
};
